module.exports = __webpack_public_path__ + "static/vr-0-1-8209e394011586b71e97cd6c643dc60b.jpg";